import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-fatal-error-modal',
    templateUrl: './fatal-error-modal.component.html',
    styleUrls: ['./fatal-error-modal.component.scss'],
    standalone: false
})
export class FatalErrorModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
